import apiLinkPreview from "./linkpreview";

export default apiLinkPreview;
